<template>
  <v-container style="padding-top: 80px">
    <div v-if="showcargando == true" id="cargando" style="z-index: 600" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
      <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-row class="ma-1">
      <v-card width="100%" class="mx-2">
        <Menu></Menu>
      </v-card>
    </v-row>
    <v-row mb-2>
      <v-chip class="ma-2 chipSize" :color="this.color" style="align-self: center" large>
        <span class="txtRep"> Reporte: {{ this.RepInd }} </span>
      </v-chip>

      <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
        <span class="txtEtiq">
          {{ this.etiqueta }}
        </span>
      </v-chip>

      <v-btn icon outlined fab color="#29B6F6" style="align-self: center" @click="Archivos()" class="btnSize">
        <v-icon dark>mdi-folder-open</v-icon>
      </v-btn>

      <v-btn
        v-if="movAutConclusion == 1 && svpuedeconcluir == 1 && saestatusolcon == 2 && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && concluirPer == true"
        style="align-self: center" class="ma-2 white--text movBtn" color="red" @click="ValidarConclusion()"
        :loading="loadingBtn">
        <v-icon start style="margin-right: 5px" color="white">mdi-archive</v-icon>
        Conclusión
      </v-btn>

      <template
        v-if="(permisoLider == true && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && horasTranscurridas <= 50 && lduslogin == uslogin) || (svpuedeconcluir == 0 && saestatusolcon == 1 && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && movSoliConclusion == 1 && AutoriConclu == true)">
        <v-btn @click="pushTo('AutorizarConclusionExpJur')" style="align-self: center" class="ma-2 white--text movBtn"
          color="#ef6c00">
          <v-icon start style="margin-right: 5px" color="white">mdi-checkbox-marked-outline</v-icon>
          Autorizar Conclusión
        </v-btn>
      </template>



      <v-alert v-if="archivado == true" dense border="left" type="warning" style="align-self:center;margin:15px;">
        <strong>Reporte Archivado</strong>
      </v-alert>

      <template v-if="desconclusion == 0">
        <v-btn
          v-if="archivado == false && desconclusionPer == true && (svfhconclusion.length > 0 || svfhcerrado.length > 0)"
          style="align-self: center" class="ma-2 movBtn" @click="pushTo('SolicitarDesconExpJur')" color="orange-darken-2">
          <v-icon start style="margin-right: 5px">mdi-folder-open</v-icon>
          Solicitar Desconclusión
        </v-btn>

      </template>
      <template v-else>
        <template
          v-if="(lduslogin == uslogin && horasTranscurridas < 96 && permisoLider == true) || (autorizaDesconclu == true && svpuedeconcluir == 0)">
          <v-btn v-if="archivado == false" @click="pushTo('AutorizarDesconExpJur')" class="ma-2 white--text movBtn"
            style="align-self: center" color="#ef6c00">
            <v-icon start style="margin-right: 5px" color="white">mdi-checkbox-marked-outline</v-icon>
            Autorizar Desconclusión
          </v-btn>

        </template>
        <template v-else>
          <v-btn class="ma-2 white--text movBtn btnProc" style="
              align-self: center;
              cursor: not-allowed;
              pointer-events: none;
            ">
            <v-icon start style="margin-right: 5px" color="gray"></v-icon>
            En Proceso de desconclusión
          </v-btn>
        </template>
      </template>

      <!--Vehiculo-->
      <v-col class="text-right">
        <template v-if="RepLeg == 1">
          <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                  mdi-car
                </v-icon>
              </v-btn>
            </template>
            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
          </v-tooltip>
          <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0" offset-x="25"
            offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                  <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                    mdi-car
                  </v-icon>
                </v-btn>
              </template>
              <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
            </v-tooltip>
          </v-badge>
          <v-tooltip v-if="svvehlib == 0 && corralon == 0 && savehlibestatus == 1" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btnVehiculoPurple" icon fab v-on="on" v-bind="attrs">
                <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                  mdi-car
                </v-icon>
              </v-btn>
            </template>
            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
          </v-tooltip>
          <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 1" offset-x="25"
            offset-y="15" overlap bottom color="orange" icon="mdi-exclamation">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btnVehiculoPurple" icon fab v-on="on" v-bind="attrs">
                  <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                    mdi-car
                  </v-icon>
                </v-btn>
              </template>
              <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
            </v-tooltip>
          </v-badge>
        </template>
        <template v-else>
          <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                <v-icon class="btnCar" color="grey-lighten-1"> mdi-car </v-icon>
              </v-btn>
            </template>
            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
          </v-tooltip>

          <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0" offset-x="25"
            offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                  <v-icon class="btnCar" color="grey-lighten-1">
                    mdi-car
                  </v-icon>
                </v-btn>
              </template>
              <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
            </v-tooltip>
          </v-badge>
        </template>

        <!--Volante Juridico-->
        <template v-if="svresponsable == '  '">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btnVehiculo" icon fab color="orange" v-on="on" v-bind="attrs">
                <v-icon color="white"> mdi-format-float-left </v-icon>
              </v-btn>
            </template>
            <span>Volante jurídico no capturado</span>
          </v-tooltip>
        </template>

        <!--Relevante-->
        <template v-if="relevante == 1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon fab color="white" v-on="on" v-bind="attrs">
                <v-icon class="btnBook" :color="sarelevante">
                  mdi-bookmark
                </v-icon>
              </v-btn>
            </template>
            <span>{{ this.redescripcion }}</span>
          </v-tooltip>
        </template>
      </v-col>
    </v-row>
    <v-row class="mt-6 mb-1 hidden-md-and-down">
      <v-card elevation="5" width="100%" class="main-buttons-container mx-3">
        <v-btn-toggle v-model="$store.state.reporteMenuOption" tile color="primary" shaped mandatory group>
          <v-btn value="DetalleExpJur" @click="pushTo('DetalleExpJur')">
            <span class="hidden-sm-and-down">Detalle General</span>
          </v-btn>
          <v-btn value="JuiciosOralesExpJur" @click="pushTo('JuiciosOralesExpJur')" v-if="juor == 1">
            Juicios Orales
          </v-btn>
          <v-btn value="CivicoExpJur" @click="pushTo('CivicoExpJur')" v-if="cico == 1">
            Juez Cívico-Conciliador
          </v-btn>

          <v-btn value="AvePreviaExpJur" @click="pushTo('AvePreviaExpJur')" v-if="avpr == 1">
            Averiguacion Previa
          </v-btn>
          <v-btn value="LiberacionVehExpJur" @click="pushTo('LiberacionVehExpJur')">
            Liberación Vehículo
          </v-btn>
          <v-btn value="VolanteExpJur" @click="pushTo('VolanteExpJur')">
            Volante Jur.
          </v-btn>
          <v-btn value="GarantiasExpJur" @click="pushTo('GarantiasExpJur')">
            Garantías
          </v-btn>
          <v-btn value="ContraloriaExpJur" v-if="percontraloria == true" @click="pushTo('ContraloriaExpJur')">
            Contralor&iacute;a
          </v-btn>
          <v-btn value="DesconclusionExpJur" v-if="ComentariosDesconclusion == true"
            @click="pushTo('DesconclusionExpJur')">
            Desconclusi&oacute;n
          </v-btn>
          <v-btn v-if="honorario == true" value="HonorarioExpJur" @click="pushTo('HonorarioExpJur')">
            Honorario
          </v-btn>
          <v-btn value="NoView" id="Ocultar" active-class="aa" :exact="true" style="display: none">
          </v-btn>
        </v-btn-toggle>
      </v-card>
    </v-row>
    <div class="reporte-menu mt-4 hidden-lg-and-up">
      <vs-collapse class="title-card-style menu-header-bg mb-1" style="height: 100% !important">
        <vs-collapse-item not-arrow class="collapsable-container">
          <div id="menuPickerCollapsable" slot="header" class="menu-header-bg">
            <p class="card-title-text">{{ mobileMenuShowedName }}</p>
          </div>
          <v-container class="pt-5 px-4 pb-0">
            <v-row>
              <v-col cols="12">
                <v-btn block text color="black" value="DetalleExpJur" @click="pushTo('DetalleExpJur')">
                  Detalle General
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="juor == 1">
                <v-btn block text color="black" value="JuiciosOralesExpJur" @click="pushTo('JuiciosOralesExpJur')">
                  Juicios Orales
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="cico == 1">
                <v-btn block text color="black" value="CivicoExpJur" @click="pushTo('CivicoExpJur')">
                  Juez Cívico-Conciliador
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="avpr == 1">
                <v-btn block text color="black" value="AvePreviaExpJur" @click="pushTo('AvePreviaExpJur')">
                  Averiguacion Previa
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-btn block text color="black" value="LiberacionVehExpJur" @click="pushTo('LiberacionVehExpJur')">
                  Liberación Vehículo
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn block text color="black" value="VolanteExpJur" @click="pushTo('VolanteExpJur')">
                  Volante Jur.
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-btn block text color="black" value="Garantias" @click="pushTo('GarantiasExpJur')">
                  Garantías
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="percontraloria == true">
                <v-btn block text color="black" value="ContraloriaExpJur" @click="pushTo('ContraloriaExpJur')">
                  Contralor&iacute;a
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="ComentariosDesconclusion == true">
                <v-btn block text color="black" value="DesconclusionExpJur" @click="pushTo('DesconclusionExpJur')">
                  Desconclusi&oacute;n
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn block v-if="honorario == true" text color="black" value="HonorarioExpJur"
                  @click="pushTo('HonorarioExpJur')">
                  Honorario
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </vs-collapse-item>
      </vs-collapse>
    </div>

    <router-view @ReloadEncabezado="RecargarHeader" :key="$route.fullPath"></router-view>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import tramite from "@/services/TramitePago/TramitePago.Service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from "@/services/ReporteGeneral/ReporteGeneral.service.js";
import Menu from "@/components/pages/operacion/MenuEstadisticas/Menu.vue";
import ConclusionServ from "@/services/Conclusion/Conclusion.service.js";
export default {
  components: {
    Menu,
  },
  data() {
    return {
      showcargando: true,
      nrreporte: "",
      svindice: "",
      aiclave: "",
      tabs: "",
      RepInd: "",
      svfhconclusion: "",
      svfhcerrado: null,
      color: "",
      etiqueta: "",
      tipo: "",
      honorario: false,
      menuBarOptions: "",
      svresponsable: "",
      mobileMenuShowedName: "",
      menuShowedProcess: "Juicios Orales",
      menuShowLibVeh: 1,
      percontraloria: true,
      ComentariosDesconclusion: true,
      juor: 1,
      cico: 1,
      avpr: 1,
      dynamicMuneOptionsData: [],

      //Botones
      RepLeg: 0,
      savehlib: 0,
      svvehlib: 0,
      savehlibestatus: 0,
      diasVeh: 0,
      corralon: 0,
      purpleCarBtn: false,
      relevante: 0,
      sarelevante: "",
      redescripcion: "",
      desconclusion: 0,
      desconclusionPer: false,
      lduslogin: "",
      svpuedeconcluir: 0,
      saestatusolcon: 0,
      permisoLider: false,
      autorizaDesconclu: false,
      concluirPer: false,
      movAutConclusion: 0,
      AutoriConclu: false,
      HorasCond: 0,
      horasTranscurridas: 0,
      uslogin: "",
      menu: "",
      colorClass: "",
      movSoliConclusion: 0,
      loadingBtn: false,
      datos: null,
      archivado: false,
    };
  },
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage", "permission"]),
    ...mapGetters(["getUser", "THEME_STATE"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  watch: {
    "$store.state.reporteMenuOption"(val) {
      if (val == "NoView") {
        this.setMobileMenuSelectedOption("NoView");
      } else this.setMobileMenuSelectedOption(val);
      this.getInitialData();
    },
    etiqueta(val) {
      if (val == "Abierto") {
        this.colorClass = "marginChip";
      } else if (val == "Concluido") {
        this.colorClass = "marginChipRed";
      } else if (val == "Cancelado") {
        this.colorClass = "marginChipPurple";
      } else if (val == "Conclusión Administrativa") {
        this.colorClass = "marginChipYellow";
      }
    },
  },
  async mounted() {
    this.menu = this.$store.state.reporteMenuOption;
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    if (this.datos.aiclave == 5) {
      this.$router.push({ name: "DetalleRCMedico" });
      //setTimeout(() => {
      //    window.location.reload();
      //}, 2000);
    } else if (this.datos.aiclave == 23) {
      this.$router.push({ name: "DetalleRLV" });
      //setTimeout(() => {
      //    window.location.reload();
      //}, 2000);
    } else if (this.datos.aiclave == 24) {
      this.$router.push({ name: "DetalleRobo" });
      //setTimeout(() => {
      //    window.location.reload();
      //}, 2000);
    }
    await this.MenuReporte();
    if (this.menu != "") {
      await this.setMenuButtonSelected();
      this.changeReporteMenuOption(this.menu);

      this.setMobileMenuSelectedOption(this.menu);
    }
    await this.getInitialData();

    this.Permisos();

    this.VerificarTramitePago();
    setTimeout(() => {
      this.showcargando = false;
    }, 2000);


    var deshabilitado = await General.VerificarReporte(this.datos);


    if (deshabilitado == 1) {
      this.archivado = true;
    }
  },
  async updated() {
    let valida = sessionStorage.getItem("Volante");
    if (valida != null) {
      sessionStorage.removeItem("Volante");
      this.setMobileMenuSelectedOption(valida);
    }
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    async MenuReporte() {
      let formData = new FormData();
      formData.append("nrreporte", this.datos.nrreporte);
      formData.append("svindice", this.datos.svindice);
      formData.append("aiclave", this.datos.aiclave);
      await General.MenuReporte(this, formData).then((data) => {
        this.juor = 0;
        this.cico = 0;
        this.avpr = 0;
        this.menuShowedProcess = data[0].nombre;
        if (data[0].nombre == "Juicios Orales") this.juor = 1;
        else if (data[0].nombre == "Civico Civil") this.cico = 1;
        else if (data[0].nombre == "AvePrev Consig") this.avpr = 1;
      });
    },
    async Permisos() {
      //los permiso de contraloria y desconclusion inician en true, para el funcionamiento correcto y esta validacion para cambiar en false si no tiene permiso
      await MetodosGenerales.verificarPermisoSolo(
        this.domain.domainNameForApi,
        "VerificarPermiso",
        "312, 318"
      ).then((response) => {
        if (response.data.length > 0) {
          var found = response.data.find((e) => e.peclave === 312);
          if (found != undefined) this.percontraloria = true;
          else this.percontraloria = false;
          found = response.data.find((e) => e.peclave === 318);
          if (found != undefined) this.ComentariosDesconclusion = true;
          else this.ComentariosDesconclusion = false;
        } else {
          this.ComentariosDesconclusion = false;
          this.percontraloria = false;
        }
      });

      //Asis Jur
      await MetodosGenerales.verificarPermisoSolo(
        this.domain.domainNameForApi,
        "VerificarPermiso",
        "91, 49,92,135,29"
      ).then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((object) => {
            if (object.peclave == 91) this.desconclusionPer = true;
            else if (object.peclave == 49) this.permisoLider = true;
            else if (object.peclave == 92) this.autorizaDesconclu = true;
            else if (object.peclave == 135) this.concluirPer = true;
            else if (object.peclave == 29) this.AutoriConclu = true;
          });
        }
      });
    },
    setMenuButtonSelected() {
      let selectedOption = this.menu;

      this.setMobileMenuSelectedOption(selectedOption);
    },

    setMobileMenuSelectedOption(value) {
      switch (value) {
        case "DetalleExpJur":
          this.mobileMenuShowedName = "Detalle General";
          break;
        case "HonorarioExpJur":
          this.mobileMenuShowedName = "Honorarios";
          break;
        case "JuiciosOralesExpJur":
          this.mobileMenuShowedName = "Juicios Orales";
          break;
        case "CivicoExpJur":
          this.mobileMenuShowedName = "Civico Civil";
          break;
        case "AvePreviaExpJur":
          this.mobileMenuShowedName = "Averiguacion Previa";
          break;

        case "LiberacionVehExpJur":
          this.mobileMenuShowedName = "Liberación Vehículo";
          break;
        case "VolanteExpJur":
          this.mobileMenuShowedName = "Volante Jur.";
          break;
        case "GarantiasExpJur":
          this.mobileMenuShowedName = "Garantías";
          break;
        case "DesconclusionExpJur":
          this.mobileMenuShowedName = "Desconclusión";
          break;
        case "ContraloriaExpJur":
          this.mobileMenuShowedName = "Contraloría";
          break;
        case "NoView":
          this.mobileMenuShowedName = "Men\u00FA";
          break;
        default:
          this.mobileMenuShowedName = "Men\u00FA";
          break;
      }
    },

    getMenuOptionsInfo() {
      let reponse = Reporte.CatalogoOpcionesMenu(this.datos, this.aiclave);
      this.dynamicMuneOptionsData = reponse.data;
    },

    async getInitialData() {
      let encabezado = await Reporte.EncabezadoReporte(this);
      this.RepInd = encabezado.nrreportei;
      this.color = encabezado.color;
      this.etiqueta = encabezado.etiqueta;
      this.tipo = parseInt(encabezado.tipo);

      //Botones
      this.RepLeg = parseInt(encabezado.RepLeg);
      this.savehlib = parseInt(encabezado.savehlib);
      this.svvehlib = parseInt(encabezado.svvehlib);
      this.savehlibestatus = parseInt(encabezado.savehlibestatus);
      this.diasVeh = parseInt(encabezado.DiasVeh);
      this.corralon = parseInt(encabezado.corralon);
      this.relevante = parseInt(encabezado.relevante);
      this.sarelevante = encabezado.sarelevante;
      this.redescripcion = encabezado.redescripcion;
      this.svresponsable = encabezado.svresponsable;
      this.lduslogin = encabezado.lduslogin;
      this.horasTranscurridas = parseInt(encabezado.horasTranscurridas);
      this.svpuedeconcluir = parseInt(encabezado.svpuedeconcluir);
      this.saestatusolcon = parseInt(encabezado.saestatusolcon);
      this.uslogin = this.getUser.get(this.permission.global).uslogin;
      this.svfhconclusion = encabezado.fhconclusion;
      this.svfhcerrado = encabezado.fhcerrado;

      var data = await Reporte.VerificarDesconclusion(this.datos);
      this.desconclusion = parseInt(data);
      this.movAutConclusion = await Reporte.MovAutConclusuion(this.datos);
      this.movSoliConclusion = await Reporte.MovSolicitud(this.datos);
    },
    pushTo(param) {
      let value = "DetalleExpJur";
      document.getElementById("menuPickerCollapsable").click();
      if (param != null && param != undefined) {
        value = param;
      }

      if (param != this.$route.name) {
        this.setMobileMenuSelectedOption(value);
        this.$router.push({ name: value });
        this.changeReporteMenuOption(param);
      }
    },
    async VerificarTramitePago() {
      let formData = new FormData();
      formData.append("reporte", this.datos.nrreporte);
      formData.append("indice", this.datos.svindice);
      tramite.VerificarTramitePago(this, formData).then((data) => {
        if (data[0].success == "true") this.honorario = true;
      });
    },
    Archivos() {
      this.$router.push({ name: `ArchivosExpJur` }).catch((error) => error);
    },
    RecargarHeader() {
      this.getInitialData();
    },
    async ValidarConclusion() {
      this.loadingBtn = true;
      let val = await ConclusionServ.ValidarConclusion(this.datos);
      if (val.mensaje != "") {
        this.$swal({
          position: "center",
          icon: "info",
          title: "Información",
          html: `${val.mensaje}`,
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#536DFE",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowHtmlTags: true,
        }).then(async () => {
          if (val.tipo == 1) {
            this.$router
              .push({
                name: "ConcluirConclusionExpJur",
                params: { auxtipo: 1 },
              })
              .catch((error) => error);
          }
        });
      } else {
        this.$router
          .push({ name: "ConcluirConclusionExpJur", params: { auxtipo: 0 } })
          .catch((error) => error);
      }
      this.loadingBtn = false;
    },
  },
};
</script>

<style>
.btnProc {
  background-color: rgb(255 82 0 / 46%) !important;
}

.overBtn {
  margin-top: -10% !important;
  margin-left: -20% !important;
}

.txtEtiq {
  color: black;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.txtRep {
  color: white;
  padding-right: 30px;
  font-size: 18px;
}

.chipSize {
  height: 45px !important;
}

.chipSmaller {
  font-size: 10px;
}

.btnSize {
  height: 45px !important;
  width: 45px !important;
}

.marginChip {
  margin-left: -40px !important;
  margin-right: 15px !important;
  background-color: white !important;
  border-color: rgb(60, 212, 160) !important;
  border: 1px solid;
}

.marginChipRed {
  margin-left: -40px !important;
  margin-right: 15px !important;
  background-color: white !important;
  border-color: red !important;
  border: 1px solid;
}

.marginChipPurple {
  margin-left: -40px !important;
  margin-right: 15px !important;
  background-color: white !important;
  border-color: rgb(144, 19, 254) !important;
  border: 1px solid;
}

.marginChipYellow {
  margin-left: -40px !important;
  margin-right: 15px !important;
  background-color: white !important;
  border-color: rgb(255, 194, 96) !important;
  border: 1px solid;
}

@media screen and (max-width: 500px) {
  .movBtn {
    font-size: 13px !important;
  }

  .btnVehiculo {
    height: 30px !important;
    width: 30px !important;
  }

  .btnVehiculoPurple {
    height: 30px !important;
    width: 30px !important;
  }

  .txtEtiq {
    color: black;
    font-size: 12px !important;
    font-weight: bold;
    text-align: center;
  }

  .txtRep {
    font-size: 15px;
  }
}

@media screen and (max-width: 767px) {
  .txtEtiq {
    color: black;
    font-size: 12px !important;
    font-weight: bold;
    text-align: center;
  }

  .txtRep {
    font-size: 16px;
  }
}

.btnCar {
  font-size: 27px !important;
}

.reporte-menu .vs-collapse-item--header {
  background-color: #2d3e4e !important;
}

.btnBook {
  transform: rotate(90deg);
  font-size: 55px !important;
  pointer-events: none;
}

.btnVehiculo {
  background-color: #ff6a00;
  font-size: 20px !important;
  height: 45px !important;
  width: 45px !important;
  margin-left: 5px;
  margin-right: 10px;
}

.btnVehiculoPurple {
  background-color: #5a57a7;
  font-size: 20px !important;
  height: 45px !important;
  width: 45px !important;
  margin-left: 5px;
  margin-right: 10px;
}

.display-on-mobile {
  display: none !important;
}

.hide-on-mobile {
  display: block !important;
}

.childIcon {
  margin-left: -12px;
  margin-top: 25px;
}

.childIconPurple {
  margin-left: -12px;
  margin-top: 25px;
}
</style>

<style scoped>
.card-title-text {
  font-size: 1.3rem !important;
  font-weight: 500 !important;
  color: white !important;
  text-align: center !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.menu-header-bg {
  background-color: #2d3e4e !important;
}

.collapsable-container {
  background-color: white;
  height: 100% !important;
}

.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.main-buttons-container {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
